export default {
    departments: [],
    selectedDepartment: {},
    error: false,
    errorMessage: '',
}



// WEBPACK FOOTER //
// ./src/modules/departments/state.js